import React from 'react'

import './styles.scss'

const Advertisement = ({ flow_tag }) => {
	return (
		<div className={`advertisementt ${flow_tag === '' ? 'legal' : ''}`}>
			<h2 className="advertisementt__title">
				Join millions who find fun with Refine
			</h2>
			<img
				src="/images/sale/global-rating.png"
				alt="global-rating"
				className={`advertisementt__image ${flow_tag === '' ? 'legal' : ''}`}
			/>
		</div>
	)
}

export { Advertisement }
